import { service } from '../../../helpers/http'

export const ActionGetShifts = ({ dispatch }, payload) => {
    
    return service({
        module: 'shift',
        action: 'shifts',
        payload: payload
    });
}

